import * as THREE from 'three';
import { jsondan } from '../../FikoThreeType';
import { FikoEksen } from '../FikoEksen';
import { FikoGrup } from '../FikoGrup';
import { FikoSahne } from '../FikoSahne';
import { FikoVektor3D } from '../FikoVektor3d';
import { FikoTakim } from './FikoTakim';
import { FikoTakimFrezeleme } from './FikoTakimFrezeleme';
import { FikoTakimYolu } from './FikoTakimYolu';
import { FikoTakimYoluv1 } from './FikoTakimYoluv1';
import { FikoVektorTakimYol3D } from './FikoVektorTakimYol3d';
import { FikoVektorTakimYol3Dv1 } from './FikoVektorTakimYol3dv1';

export class FikoAPTv1 extends FikoGrup {
    override type: any = "FikoAPTv1";
    /** */
    sagButonlar: any[] = [
        {
            isim: "Similasyon Yap",
            simge: "play",
            tiklandi: () => {
                import('../fiko-similasyon-v1/fiko-similasyon-v1.component').then(m => {
                    const gosterim = this.sahne?.anaGosterim ?? (this as any).parent?.sahne?.anaGosterim;
                    if (!gosterim?.DialogFiko) { console.warn('DialogFiko bulunamadi'); return; }
                    gosterim.DialogFiko.ac({
                        bilesen: m.FikoSimilasyonV1Component,
                        parametreler: { anaNesne: this },
                        ayarlar: { baslik: 'Similasyon', simgeResim: './simgeler/takimyolu.webp' }
                    });
                });
            }
        },
        {
            isim: "hesapla",
            simge: "calculator",
            tiklandi: () => {
                this.isle()
            }
        },
    ]
    /** */
    sagMenu: any[] = [
        {
            simge: null,
            baslik: "Düzenle",
            tiklandi: () => {
                // this.sahne.anaGosterim.DialogFikoApt.ac(this as any);
            }
        },
        {
            simge: null,
            baslik: "Sil",
            tiklandi: () => {
                while (this.children.length) {
                    this.remove(this.children[0]);
                }

                this.parent.remove(this);

                this.sahne.anaGosterim.FikoYT.degisti.emit();
                this.sahne.anaGosterim.ciz();
            }
        }
    ]
    /** */
    aracCubugu: any[] = [
        {
            simge: "edit",
            baslik: "Düzenle",
            tiklandi: () => {

            }
        },
        {
            simge: "trash alternate",
            baslik: "Sil",
            renkSinif: "red",
            tiklandi: () => {
                this.veri = null;
                // this.aktiviteler = [];
                while (this.children.length) {
                    this.remove(this.children[0]);
                }

                this.parent.remove(this);
                this.sahne.anaGosterim.aktifItem = null;
                this.sahne.anaGosterim.FikoYT.degisti.emit();
                this.sahne.anaGosterim.ciz();
            }
        }
    ]

    public override get liste(): any[] {
        return this.children as any[];
    }

    veri: any;
    constructor(public override sahne?: FikoSahne, name?: string, data?: any) {
        super(sahne);
        this.name = name;

        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = false;
        this.userData['FikoArayuz'].simge = "./simgeler/apt.webp";

        this.veri = data;
        this.userData['aciklama'] = data?.aciklama
    }



    ciftTiklandi() {
        // this.sahne.anaGosterim.DialogFikoApt.ac(this);
    }

    sagTiklandi() {
    }


    isle() {
        let sonTakim: any = null;
        let sonTakimYonu: THREE.Vector3 = null;
        let sonHiz: any = null;
        let sonHizTuru: any = null;
        let sonDevir: any = null;
        let sonKoor: THREE.Vector3 = null;

        let aktivite: any;

        let noktaEkle = (): any => {
            if (!sonKoor) return;
            let nokta = new FikoVektorTakimYol3Dv1()
            nokta.copy(sonKoor);
            nokta.devir = sonDevir;
            nokta.hiz = sonHiz;
            nokta.hareketTuru = sonHizTuru;
            nokta.takimYonu.copy(sonTakimYonu);
            nokta.takim = sonTakim;
            return nokta
        };
        let satirIsle = (satir: string): any => {
            if (satir.startsWith("TKMYON ")) {
                sonTakimYonu = new THREE.Vector3().fromArray(satir.replace("TKMYON ", "").split(",").map((val) => Number(val)))
                sonTakimYonu.transformDirection(
                    new THREE.Matrix4().makeBasis(
                        new THREE.Vector3().fromArray(aktivite.islemeEkseni.x),
                        new THREE.Vector3().fromArray(aktivite.islemeEkseni.y),
                        new THREE.Vector3().fromArray(aktivite.islemeEkseni.z)
                    )
                )
                // console.log(sonTakimYonu)
            } else if (satir.startsWith("TAKIM ")) {
                let tkmPrm = satir.replace("TAKIM ", "").split(",").map((val) => Number(val))
                sonTakim = new FikoTakimFrezeleme(this.sahne, tkmPrm[0], tkmPrm[1], 200, tkmPrm[tkmPrm.length - 1])
                // console.log(sonTakim)
            } else if (satir.startsWith("DEVIR ")) {
                let devirPrm = satir.replace("DEVIR ", "").split("|")
                sonDevir = Number(devirPrm[0])
                // console.log(devirPrm[0])
            } else if (satir.startsWith("ILERLEME ")) {
                let ilerlemePrm = satir.replace("ILERLEME ", "").split("|")
                sonHiz = Number(ilerlemePrm[0])
                sonHizTuru = ilerlemePrm[2]
                // console.log(ilerlemePrm[0])
            } else if (satir.startsWith("GIT ")) {
                let pozPrm = satir.replace("GIT ", "").split(",").map((val) => Number(val));
                let koor = new THREE.Vector3().fromArray(pozPrm);
                let eksenO = new THREE.Vector3().fromArray(aktivite.islemeEkseni.merkez);

                koor.applyQuaternion(
                    new THREE.Quaternion().setFromRotationMatrix(new THREE.Matrix4().makeBasis(
                        new THREE.Vector3().fromArray(aktivite.islemeEkseni.x),
                        new THREE.Vector3().fromArray(aktivite.islemeEkseni.y),
                        new THREE.Vector3().fromArray(aktivite.islemeEkseni.z)
                    )
                    )
                )

                koor.add(eksenO.clone())

                sonKoor = koor
                // console.log(koor)
                return noktaEkle()
            }
        }

        for (let i = 0; i < this.veri.aktiviteler.length; i++) {
            aktivite = this.veri.aktiviteler[i];
            aktivite.noktalar = [];
            let tkmYoluv1 = new FikoTakimYoluv1(this.sahne, aktivite.ismi);
            tkmYoluv1.aktivite=aktivite
            for (let aktapti = 0; aktapti < aktivite.apt.length; aktapti++) {
                const satir = aktivite.apt[aktapti];
                const nokta = satirIsle(satir);
                if (nokta) {
                    nokta.aktivite = tkmYoluv1;
                    nokta.program = this;
                    aktivite.noktalar.push(nokta)
                }
            }
            aktivite.apt = undefined;
            delete aktivite.apt;
            tkmYoluv1.noktalar = aktivite.noktalar
            this.ekle(tkmYoluv1);
            aktivite = undefined;
        }
        this.veri.aktiviteler = undefined;
        delete this.veri.aktiviteler;

        this.sahne.anaGosterim.ciz();
        this.sahne.anaGosterim.FikoYT.degisti.emit();
    }

    override toJSON(meta?: { geometries: any; materials: any; textures: any; images: any }): any {
        return
    }

    static fromJson(sahne?: FikoSahne, parent?: any, json?: any) {
        const _rslt = new FikoAPTv1(sahne, json.isim);

        return _rslt;
    }
}